import axios from "axios";
import API_URL from "../config/config";

export const PICKUP_SCHEDULE_MINUTES = 30;

export const fetchScheduledOrderMinimumTime = async (distanceKm) => {
  const numericDistance = Number(distanceKm);

  if (!Number.isFinite(numericDistance) || numericDistance <= 0) {
    return null;
  }

  try {
    const response = await axios.get(
      `${API_URL}/admin/crm/scheduled-time/minimum`,
      {
        params: {
          distanceKm: numericDistance,
        },
      }
    );

    const minimumMinutes = Number(
      response?.data?.data?.timeMinutes ?? response?.data?.timeMinutes
    );

    return Number.isFinite(minimumMinutes) && minimumMinutes > 0
      ? minimumMinutes
      : null;
  } catch (error) {
    console.error(
      "Failed to fetch scheduled order minimum time:",
      error?.message || error
    );
    return null;
  }
};

export const fetchScheduledOrderMinimumTimes = async (distances = []) => {
  const numericDistances = (distances || []).map((distance) => Number(distance) || 0);
  const results = await Promise.all(
    numericDistances.map((distance) => fetchScheduledOrderMinimumTime(distance))
  );

  return results.map((minutes) =>
    Number.isFinite(Number(minutes)) && Number(minutes) > 0
      ? Number(minutes)
      : null
  );
};
